/**
 * The two string orders (round 7, SonarQube typescript:S2871; docs/security/sonar-triage.md).
 *
 * `byCodeUnit` is exactly what a bare `.sort()` does to strings (UTF-16 code unit order), written
 * out so the choice is visible. Use it wherever the order is persisted, hashed, exported or
 * compared: the audit chain and its export manifests, seed drift, migration files, the release
 * manifest, cache keys, ISO-8601 instants. It never depends on the runtime's locale, so the web,
 * the runner and the client agree byte for byte.
 *
 * `byDisplayText` is for a list a person reads (a filter's options, a list of names): the
 * locale's collation, so "acme" is not put after "Zeta". Never use it for an order that is
 * stored or compared, since it can differ between runtimes.
 */
export function byCodeUnit(a: string, b: string): number {
  if (a < b) return -1;
  return a > b ? 1 : 0;
}

export function byDisplayText(a: string, b: string): number {
  return a.localeCompare(b);
}
